import React from "react";
import Footer from "../components/Shared/Footer";
import ReducarbVariant from "../components/Shared/reducarb-variant";

const ReducarbVariants = () => {

  return (
    <div>
      <section className="breadcrumb-section pt-0">
        <div className="container-fluid-lg">
          <div className="row">
            <div className="col-12">
              <div className="breadcrumb-contain">
                <h2>Reducarb Variants</h2>
                <nav>
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <a href="/">
                        <i className="fa-solid fa-house"></i>
                      </a>
                    </li>
                    <li className="breadcrumb-item active">
                    <span className="fw-bold">Redu</span>carb Variants
                    </li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </section>
      
<div className="container-fluid-lg">
    <div className="row">
        <div className="col-xl-4 mt-3">

        </div>
        <div className="col-xl-8 mt-3">
    
      <p className="font-xsm">
        <strong><span style={{color: 'var(--theme-color1)'}}>Redu</span><span style={{color: 'var(--theme-color)'}}>carb</span> HIM and HER are designed based on the gender specific nutritional needs 
            and current dietary intakes of various nutrients. The differences are as follows:</strong></p>

  </div>
    </div>

</div>
<ReducarbVariant/>

<section className="fresh-vegetable-section section-lg-space">
  <div className="container-fluid-lg">
    <div className="review-title mb-3">
      <h1 className="font-lg mb-2">References:</h1>
    </div>
    <div className="references">
      <p><strong>1.</strong> <a href="#" className="hover-green-refernce font-xsm">Heart.org/en/healthy-living/healthy-eating/eat-smart/sugar/added-sugars </a></p>
      <p><strong>2.</strong> <a href="#" className="hover-green-refernce font-xsm">Bennett E, et al. BMJ Open 2018;8:e020017. doi:10.1136/bmjopen-2017-020017</a></p>
      <p><strong>3.</strong> <a href="#" className="hover-green-refernce font-xsm">ICMR NIN 2020</a></p>
      <p><strong>4.</strong> <a href="#" className="hover-green-refernce font-xsm">www.thelancet.com Vol 14 July, 2023</a></p>
      <p><strong>5.</strong> <a href="#" className="hover-green-refernce font-xsm">https://www.mayoclinic.org/healthy-lifestyle/womens-health/in-depth/belly-fat/art-20045809 </a></p>
      <p><strong>6.</strong> <a href="#" className="hover-green-refernce font-xsm">Zhao et al. Nutrition Journal (2020) 19:45</a></p>
      <p><strong>7.</strong> <a href="#" className="hover-green-refernce font-xsm">Nutrients 2022, 14, 2641. https://doi.org/10.3390/nu14132641</a></p>
    </div>
  </div>
</section>

      <div>
        <Footer />
      </div>
    </div>
  );
};

export default ReducarbVariants;
